/** @format */

import { ENUM_MAIL_TYPE } from "@prisma/client";
import {
  Button,
  ButtonType,
  ButtonVariant,
  TextAreaInput,
  TextInput,
  Toast,
} from "@roadflex/react-components-www";
import { useLandingPageFormSubmission } from "@roadflex/react-hooks-www";
import { handleGoogleReCaptchaSubmit } from "@roadflex/web-lib";
import getConfig from "next/config";
import { useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const { publicRuntimeConfig } = getConfig();
const { RECAPTCHA_SITE_KEY } = publicRuntimeConfig;

export default function Panel4() {
  const {
    values,
    handleChange,
    handleSubmit,
    handleBlur,
    errors,
    isSubmitting,
    touched,
    resetForm,
  } = useLandingPageFormSubmission({
    initialValues: {
      landingPageMailType: ENUM_MAIL_TYPE.PARTNERSHIPS,
      firstName: "",
      lastName: "",
      companyName: "",
      companyWebsite: "",
      email: "",
      role: "",
      yearsInBusiness: "",
      description: "",
    },
    onSubmit(res, err) {
      if (err) {
        Toast({
          type: "error",
          message: err?.message,
        });
        return;
      }
      if (res?.code === "200") {
        Toast({
          type: "success",
          message: res.message,
        });
      } else {
        Toast({
          type: "error",
          message: res?.message,
        });
      }
      resetForm();
    },
  });

  const captchaRef = useRef<ReCAPTCHA>(null);
  return (
    <div className="w-full h-full bg-cover bg-stary-background">
      <div className="container flex flex-col items-center justify-center w-full min-h-full my-14 md:my-28">
        <div className="mb-8 text-xl text-center md:text-3xl">
          <span className="font-bold text-white">
            Become a <span className="text-orange-500">RoadFlex</span> Partner
          </span>
        </div>
        <div className="mb-8 text-base text-center text-white md:text-lg 3xl:text-xl">
          <span className="">
            If you are interested in creating a partnership with RoadFlex,
            please fill out the application form. We will review your
            application and we will get back to you shortly.
          </span>
        </div>
        <form
          className="w-full border-0 max-w-[800px] "
          onSubmit={(event) => {
            handleGoogleReCaptchaSubmit(event, captchaRef, handleSubmit);
          }}
          // onSubmit={handleSubmit}
        >
          <div className="grid w-full gap-2 md:gap-8">
            <div className="relative col-span-12 md:col-span-12">
              <TextInput
                label=" First (and Middle) Name"
                name="firstName"
                value={values.firstName}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.firstName && Boolean(errors.firstName)}
                errorMessage={errors.firstName}
                touched={touched.firstName}
                variant="responsive"
                color="text-white"
                required
              ></TextInput>
            </div>

            <div className="relative col-span-12 md:col-span-12">
              <TextInput
                label="Last Name"
                name="lastName"
                value={values.lastName}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.lastName && Boolean(errors.lastName)}
                errorMessage={errors.lastName}
                touched={touched.lastName}
                variant="responsive"
                color="text-white"
                required
              ></TextInput>
            </div>
            <div className="relative col-span-12 md:col-span-12">
              <TextInput
                label="Work Email"
                name="email"
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.email && Boolean(errors.email)}
                errorMessage={errors.email}
                touched={touched.email}
                variant="responsive"
                color="text-white"
                required
              ></TextInput>
            </div>

            <div className="relative col-span-12 md:col-span-12">
              <TextInput
                label="Company Name"
                name="companyName"
                value={values.companyName}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.companyName && Boolean(errors.companyName)}
                errorMessage={errors.companyName}
                touched={touched.companyName}
                variant="responsive"
                color="text-white"
                required
              ></TextInput>
            </div>

            <div className="relative col-span-12 md:col-span-12">
              <TextInput
                label="Role/Title"
                name="role"
                value={values.role}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.role && Boolean(errors.role)}
                errorMessage={errors.role}
                touched={touched.role}
                variant="responsive"
                color="text-white"
                required
              ></TextInput>
            </div>

            <div className="relative col-span-12 md:col-span-12">
              <TextInput
                label="Company Website"
                name="companyWebsite"
                value={values.companyWebsite}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.companyWebsite && Boolean(errors.companyWebsite)}
                errorMessage={errors.companyWebsite}
                touched={touched.companyWebsite}
                variant="responsive"
                color="text-white"
                required
              ></TextInput>
            </div>
            <div className="relative col-span-12 md:col-span-12">
              <TextInput
                label="Years in Business"
                name="yearsInBusiness"
                value={values.yearsInBusiness}
                type="number"
                max={999}
                min={0}
                onChange={handleChange}
                onBlur={handleBlur}
                error={
                  touched.yearsInBusiness && Boolean(errors.yearsInBusiness)
                }
                errorMessage={errors.yearsInBusiness}
                touched={touched.yearsInBusiness}
                variant="responsive"
                color="text-white"
                required
              ></TextInput>
            </div>

            <div className="relative col-span-12 md:col-span-12">
              <TextAreaInput
                label="Please describe your business model and why you'd like to be
              a partner"
                name="description"
                value={values.description}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.description && Boolean(errors.description)}
                errorMessage={errors.description}
                touched={touched.description}
                rows={4}
                maxLength={200}
                variant="responsive"
                color="text-white"
                required
              ></TextAreaInput>
            </div>
          </div>
          <ReCAPTCHA
            className="invisible recaptcha"
            sitekey={RECAPTCHA_SITE_KEY}
            ref={captchaRef}
            size="invisible"
          />
          <div className="flex items-center justify-center w-full mt-4 md:mt-10">
            <Button
              type={ButtonType.Submit}
              variant={ButtonVariant.Orange}
              className="sm:!px-20 font-medium"
              disabled={isSubmitting}
              loading={isSubmitting}
            >
              Apply
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
